export default "https://d1e6s5z4lzmgxx.cloudfront.net/ba82fc54-f5ca-4442-8850-d050cbc89c21/images/applause-icon.png?f4925efc152c51192b1a2cc8f7b8b803";